<template>
  <div>
    <div />
  </div>
</template>

<script>
export default {
  name: 'VbEstimates',
  components: {},
}
</script>
